import { render, staticRenderFns } from "./deposit-table-cd-data.vue?vue&type=template&id=b8ff76d4"
import script from "./deposit-table-cd-data.vue?vue&type=script&lang=js"
export * from "./deposit-table-cd-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports